if (!customElements.get('collection-menu')) {
    customElements.define(
      'collection-menu',
        class CollectionMenu extends HTMLElement {
            constructor() {
                super();
                this.toggleButton = this.querySelector('.collection-dropdown-trigger')
                this.bindEvents();
            }

            bindEvents() {
              this.toggleButton.addEventListener('click', this.toggleDropdownMenu.bind(this))
            }

            toggleDropdownMenu(e) {
              e.preventDefault();
              this.classList.toggle('open')
            }

        }
    );
}